const namespacePDF = '[PDF]';

export const PDF_GET_CLASS_PASSWORDS = `${namespacePDF} GET CLASS PASSWORDS`;
export const PDF_SEND_TEACHER_CERTIFICATE = `${namespacePDF} SEND TEACHER CERTIFICATE`;
export const PDF_SEND_TEACHER_CERTIFICATE_FAILED = `${namespacePDF} SEND TEACHER CERTIFICATE FAILED`;
